import { purchasedTokenSkeletonStyle as styles } from "./purchasedTokenSkeleton.tailwind";
const PurchasedTokenListingSkeleton = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.skeleton} />
      ))}
    </>
  );
};

export default PurchasedTokenListingSkeleton;
